import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import { GET_BLOSTER_FINAL_STAGE_INS_PARAMS, GET_BLOSTER_FRAMEL_COMPL_INS_PARAMS, GET_BLOSTER_STAGE_INS_PARAMS, GET_BREAK_BEAM_LH_PARAMS, GET_SIDE_FRAME_LH_PARAMS ,ADD_BOLSTER_STAGE_INSPECTION , LIST_BOLSTER_STAGE_INSPECTION, ADD_BOLSTER_FINAL_SI,LIST_BOLSTER_FINAL_SI,ADD_BOGIE_FRAME_COMPLETE,LIST_BOGIE_FRAME_COMPLETE,ADD_BREAK_BEAM_INSPECTION,LIST_BREAK_BEAM_INSPECTION, ADD_SIDE_FRAME_SI,LIST_SIDE_FRAME_SI,VIEW_BOLSTER_STAGE_INSPECTION,FETCH_MASTER_BOSTER_NO,FETCH_SPRING_TYPES,FETCH_BOGIE_DRAWING_NO,FETCH_CAPACITY,FETCH_MASTER_BOGIE_FRAME_NO,FETCH_MASTER_SIDE_FRAME_NO,FETCH_MASTER_BREAK_BEAM_NO,FETCH_MASTER_BOGIE_NO,VIEW_BOLSTER_FINAL_SI,VIEW_BREAK_BEAM_INSPECTION,VIEW_SIDE_FRAME_INSPECTION,VIEW_BOGIE_FRAME_INSPECTION,GET_BOGGIE_FORM, STAGE_INSP_LINE_ASSEMBLY,UPDATE_BOGIE_FLOW,GET_BOGIE_FLOW_HISTORY,ADD_ASSEMBLY_STAGE_INP_LINE,
  LIST_ASSEMBLY_STAGE_INP_LINE,
  FETCH_BOGIE_ASSEMBLY_INS_BY_ID,
  FETCH_MASTER_BOGIE_FRAME_TYPE,
  VIEW_BOGIE_ASSEMBLY_INSPECTION_FORM,
  UPDATE_ALL_ONE_ACTION_LATEST,
  BOGIE_ASSEMBLY_FLOW_HISTROY,
  BOGIE_ASSEMBLY_COMPLETED_STAGE,
  ADD_ASSEMBLY_STAGE_STATIC_LOAD_DATA,
  LIST_ASSEMBLY_STAGE_STATIC_LOAD_DATA,
  VIEW_ASSEMBLY_STAGE_STATIC_LOAD_DATA,
  FETCH_BOGIE_STATIC_LOAD_ASSEMBLY_INS_BY_ID,
  BOGIE_ASSEMBLY_STATIC_FLOW_HISTROY,
  BOGIE_ASSEMBLY_STAGE_INSPECTION_DELETE,
  BOGIE_ASSEMBLY_STATIC_LOAD_DELETE,
  DELETE_BOGIE_FABRICATION_DATA,
  STORE_DEFECT_MANAGEMENT,
} from '../../../api/apiConstant';


export const fetchBlosgterStageInsForm = createAsyncThunk(
  'boggie/fetchBlosgterStageInsForm',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_BLOSTER_STAGE_INS_PARAMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchBlosgterFinalStageInsForm = createAsyncThunk(
  'boggie/fetchBlosgterFinalStageInsForm',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_BLOSTER_FINAL_STAGE_INS_PARAMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);
export const fetchBlosgterFrameComplInsForm = createAsyncThunk(
  'boggie/fetchBlosgterFrameComplInsForm',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_BLOSTER_FRAMEL_COMPL_INS_PARAMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);
export const fetchBreakFrameLHForm = createAsyncThunk(
  'boggie/fetchBreakFrameLHForm',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_BREAK_BEAM_LH_PARAMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);
export const fetchSideFrameLHForm = createAsyncThunk(
  'boggie/fetchSideFrameLHForm',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_SIDE_FRAME_LH_PARAMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const addBlosgterStageInsForm = createAsyncThunk(
  'boggie/addBlosgterStageInsForm',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_BOLSTER_STAGE_INSPECTION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add bolster stage inspection data',
      );
    }
  },
);

// export const listBlosgterStageInsForm = createAsyncThunk(
//   'boggie/listBlosgterStageInsForm',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(LIST_BOLSTER_STAGE_INSPECTION);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
//     }
//   },
// );
export const listBlosgterStageInsForm = createAsyncThunk(
  'boggie/listBlosgterStageInsForm',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_BOLSTER_STAGE_INSPECTION, {
        params,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const addBlosgterFinalStageInsForm = createAsyncThunk(
  'boggie/addBlosgterFinalStageInsForm',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_BOLSTER_FINAL_SI, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add bolster final stage inspection data',
      );
    }
  },
);

export const listBlosterFinalStageInsForm = createAsyncThunk(
  'boggie/listBlosterFinalStageInsForm',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_BOLSTER_FINAL_SI, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const addBogieFrameComplete = createAsyncThunk(
  'boggie/addBogieFrameComplete',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_BOGIE_FRAME_COMPLETE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add bogie frame complete data',
      );
    }
  },
);

export const listBogieFrameComplete = createAsyncThunk(
  'boggie/listBogieFrameComplete',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_BOGIE_FRAME_COMPLETE, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const addBreakBeamInspection = createAsyncThunk(
  'boggie/addBreakBeamInspection',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_BREAK_BEAM_INSPECTION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add bogie frame complete data',
      );
    }
  },
);

export const listBreakBeamInspection = createAsyncThunk(
  'boggie/listBreakBeamInspection',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_BREAK_BEAM_INSPECTION, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const addSideFrameSi = createAsyncThunk(
  'boggie/addSideFrameSi',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_SIDE_FRAME_SI, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add bogie frame complete data',
      );
    }
  },
);

export const listSideFrameSi = createAsyncThunk(
  'boggie/listSideFrameSi',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_SIDE_FRAME_SI, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const stageInspLineAssembly = createAsyncThunk(
  'boggie/stageInspLineAssembly',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STAGE_INSP_LINE_ASSEMBLY, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);
export const getBoggieForm50008B = createAsyncThunk(
  'boggie/getBoggieForm50008B',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_BOGGIE_FORM, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchviewBolsterStageInspection = createAsyncThunk(
  'boggie/fetchviewBolsterStageInspection',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_BOLSTER_STAGE_INSPECTION, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchSpringTypes = createAsyncThunk(
  'boggie/fetchSpringTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SPRING_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchMasterBosterNo = createAsyncThunk(
  'boggie/fetchMasterBosterNo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_BOSTER_NO);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchBogieDrawingNumber = createAsyncThunk(
  'boggie/fetchBogieDrawingNumber',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_BOGIE_DRAWING_NO);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch drawing numbers',
      );
    }
  },
);

export const fetchCapacity = createAsyncThunk(
  'boggie/fetchCapacity',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_CAPACITY);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchBogieFrameNo = createAsyncThunk(
  'boggie/fetchBogieFrameNo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_BOGIE_FRAME_NO);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchBogieFrameType = createAsyncThunk(
  'boggie/fetchBogieFrameType',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_BOGIE_FRAME_TYPE);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchSideFrameMasterNo = createAsyncThunk(
  'boggie/fetchSideFrameMasterNo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_SIDE_FRAME_NO);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchBreakBeamMasterNo = createAsyncThunk(
  'boggie/fetchBreakBeamMasterNo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_BREAK_BEAM_NO);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchBogieNo = createAsyncThunk(
  'boggie/fetchBogieNo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_MASTER_BOGIE_NO);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchviewBolsterFinalStageInspection = createAsyncThunk(
  'boggie/fetchviewBolsterFinalStageInspection',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_BOLSTER_FINAL_SI, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchviewBogieFrameInspection = createAsyncThunk(
  'boggie/fetchviewBogieFrameInspection',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_BOGIE_FRAME_INSPECTION, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchviewSideFrameInspection = createAsyncThunk(
  'boggie/fetchviewSideFrameInspection',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_SIDE_FRAME_INSPECTION, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchviewBreakBeamInspection = createAsyncThunk(
  'boggie/fetchviewBreakBeamInspection',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_BREAK_BEAM_INSPECTION, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const UpdateBogieFlowStatus = createAsyncThunk(
  'boggie/UpdateRoofFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_BOGIE_FLOW, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update flow status',
      );
    }
  },
);

export const fetchBogieFlowHistory = createAsyncThunk(
  'boggie/fetchBogieFlowHistory',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_BOGIE_FLOW_HISTORY, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history'
      );
    }
  },
);


export const addAssemblyStageInpLine = createAsyncThunk(
  'boggie/addAssemblyStageInpLine',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_ASSEMBLY_STAGE_INP_LINE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add assembly stage inspection data',
      );
    }
  },
);

export const listBogieAssembly = createAsyncThunk(
  'boggie/listBogieAssembly',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_ASSEMBLY_STAGE_INP_LINE, {params:{...data}});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add assembly stage inspection data',
      );
    }
  },
);

export const fetchBogieAssemblyById = createAsyncThunk(
  'boggie/fetchBogieAssemblyById',
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_BOGIE_ASSEMBLY_INS_BY_ID, body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const viewBogieAssemblyForm = createAsyncThunk(
  'boggie/viewBogieAssemblyForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_BOGIE_ASSEMBLY_INSPECTION_FORM, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const boggieAssemblyInspectionAction = createAsyncThunk(
  'boggie/boggieAssemblyInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, {...formData});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchBogieAssemblyFlowHistory = createAsyncThunk(
  'boggie/fetchBogieAssemblyFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(BOGIE_ASSEMBLY_FLOW_HISTROY, {id});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchCompletedStages  = createAsyncThunk(
  'boggie/fetchCompletedStages ',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(BOGIE_ASSEMBLY_COMPLETED_STAGE, {params:{...formData}});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const addAssemblyStaticLoadTest = createAsyncThunk(
  'boggie/addAssemblyStaticLoadTest',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_ASSEMBLY_STAGE_STATIC_LOAD_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add assembly stage inspection data',
      );
    }
  },
);


export const listBogieStaticLoadAssembly = createAsyncThunk(
  'boggie/listBogieStaticLoadAssembly',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_ASSEMBLY_STAGE_STATIC_LOAD_DATA, {params:{...data}});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add assembly stage inspection data',
      );
    }
  },
);

export const viewBogieStaticLoadAssemblyForm = createAsyncThunk(
  'boggie/viewBogieStaticLoadAssemblyForm',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_ASSEMBLY_STAGE_STATIC_LOAD_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to view assembly stage inspection data',
      );
    }
  },
);

export const fetchBogieStaticLoadAssemblyById = createAsyncThunk(
  'boggie/fetchBogieStaticLoadAssemblyById',
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_BOGIE_STATIC_LOAD_ASSEMBLY_INS_BY_ID, body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const fetchBogieStaticLoadAssemblyFlowHistory = createAsyncThunk(
  'boggie/fetchBogieStaticLoadAssemblyFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(BOGIE_ASSEMBLY_STATIC_FLOW_HISTROY, {id});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const deleteBogieAssembly = createAsyncThunk(
  'boggie/deleteBogieAssembly',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(BOGIE_ASSEMBLY_STAGE_INSPECTION_DELETE, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Delete failed'
      );
    }
  }
);

export const deleteBogieAssemblyStaticLoad = createAsyncThunk(
  'boggie/deleteBogieAssembly',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(BOGIE_ASSEMBLY_STATIC_LOAD_DELETE, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Delete failed'
      );
    }
  }
);

export const deleteBogieFabrication = createAsyncThunk(
  'furnishing/deleteBogieFabrication',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_BOGIE_FABRICATION_DATA, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

// Store Defect Management
export const storeDefectManagement = createAsyncThunk(
  'boggie/storeDefectManagement',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_DEFECT_MANAGEMENT, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to store defect management data',
      );
    }
  },
);